import { EVENT_TYPES } from 'utils/dataTypes';
import {
  validateEntranceLimit,
  validateSimultaneousLimit,
} from 'modules/workflowNodeEditors/components/StartNodeEditor/EntranceLimitForm/EntranceLimitForm.utils';

export type ErrorStub = {
  hasError: boolean;
  message: string;
};

/** Basic error stub to be used in conjunction with form fields */
export const getErrorStub = (): ErrorStub => ({ hasError: false, message: '' });

/**
 * Checks if input satisfies numerical range validations and
 * invokes provided callback with whether error has occurred and
 * error text to be displayed
 */
export const validateNumberRange = (
  input: string | number,
  {
    min,
    max,
    minMessage,
    maxMessage,
    defaultMessage,
  }: {
    min: number;
    minMessage?: string;
    max: number;
    maxMessage?: string;
    defaultMessage?: string;
  },
) => {
  let hasError = false;
  let message = '';

  // convert the input to number
  const numberInput = Number(input);

  // check if it is a whole number
  const isWholeNumber = Number.isInteger(numberInput);

  if (!isWholeNumber) {
    hasError = true;
    message = 'Must be a whole number';
  } else if (min && typeof min === 'number' && min > numberInput) {
    hasError = true;
    message = minMessage || defaultMessage || `Input cannot be less than ${min}`;
  } else if (max && typeof max === 'number' && max < numberInput) {
    hasError = true;
    message = maxMessage || defaultMessage || `Input cannot exceed ${max}`;
  }

  return { hasError, message };
};

// list of properties that should not have the campaign label field
export const EXCLUDED_CAMPAIGN_LABEL_PROPERTIES = [EVENT_TYPES.USER, EVENT_TYPES.CUSTOM_EVENT];

// utils that have been migrated to new StartNodeEditor folder
export { validateEntranceLimit, validateSimultaneousLimit };
